import { getStoreDefaultLocales } from "../store-components/utils/StoreConfigManager";

export default {
    name: 'hashPath',

    // Custom language lookup function that parses hash history instead of pathname
    // window.location.pathname does not record path so we instead use the hash history created by the history library (used by react-router-dom)
    lookup(options) {
        const storeAvailableLanguages = getStoreDefaultLocales();
        let found = storeAvailableLanguages.length > 0 ? storeAvailableLanguages[1] : '';
        if (typeof window !== 'undefined') {
            const language = window.location.hash.split('/');
            if (language instanceof Array) {
                if (language[options.lookupFromHashPathIndex] && options.availableLanguages.includes(
                    language[options.lookupFromHashPathIndex])) {

                    if (typeof options.lookupFromHashPathIndex === 'number') {
                        found = language[options.lookupFromHashPathIndex].replace('/', '');
                    } else {
                        found = language[0].replace('/', '');
                    }
                }
            }
        }
        console.log({found});
        return found;
    }
  };
